import "../packs/application.sass"

import $ from "jquery"
import "popper.js"
import "bootstrap/dist/js/bootstrap"
import "slick-carousel"

window.jQuery = $
window.$ = $

import "../src/application/button_effects"
import "../src/application/counter"
import "../src/application/google_analytics"
import "../src/application/image_carousel"
import "../src/application/init_klaro"
import "../src/application/job_statements"
import "../src/application/microsoft_uet"
import "../src/application/modernizr-custom"
import "../src/application/sal"
import "../src/application/sentry"
